module.exports = __webpack_public_path__ + "img/anna-and-the-ghost.b37d4a6b.jpg";